import modalSelectBranch from './modal-select-branch-b2b-user/modal-select-branch-b2b-user.view.html';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';

let inject = [
    '$scope',
    'LoginService',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'CartService',
    'SessionService',
    '$uibModal',
    '$mdToast',
    'ByFavoritesService'
];

class LoginController {
    constructor($scope,
                LoginService,
                $state,
                $rootScope,
                SharedService,
                $timeout,
                ngAuthSettings,
                CartService,
                SessionService,
                $uibModal,
                $mdToast,
                ByFavoritesService) {
        this.ByFavoritesService = ByFavoritesService;
        this.$state = $state;
        this.SessionService = SessionService;
        this.activateTab = 0;
        this.ngAuthSettings = ngAuthSettings;
        this.CartService = CartService;
        // this.$scope = $scope;
        this.loadingRpass=false;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.errorLogin = '';
        this.LoginService = LoginService;
        this.$uibModal = $uibModal;
        this.$mdToast = $mdToast;
        this.SharedService = SharedService;
        this.user = {};
        this.newUser = {
            branchCity: ''
        };
        this.documentTypes = [];
        this.restoreAccount = '';
        this.invalidUserOrPass = false;
        this.validateRestore = false;
        this.passwordInvalid = false;
        this.thirdDocumentInvalid = false;
        this.userEmailInvalid = false;
        this.validatingDocument = false;
        this.validatingEmail = false;
        this.validatingLogin = false;
        this.showSelectModal = false;
        this.successMessage = false;
        this.errorMessageRegister = false;
        this.validatingCreateUser = false;
        this.errorRestoringAccount = false;
        this.successRestoringAccount = false;
        this.recoveryPasswordDataLoading = false;
        this.recoveryPasswordDataReceived = false;
        this.recoveryPasswordIsAValidUser = false;
        this.errorRecoveryPassword = '';
        this.active = 0;
        this.loginDataForm = {};
        this.loginDataForm.email = undefined;
        this.recoveryPasswordDataForm = {};
        this.pageName = "PAG-6";
        this.SharedService.getCMSBanners(this.pageName).then(response => {
            this.cmsData = response;
            this.shCtrl.setTags(this.cmsData.seo);
        });

    }

    $onInit() {
        try {
            let userId = this.shCtrl.globals.currentUser.userId;
            this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
        } catch (e) {

        }
        if (__env.adaptative){
            angular.element(document).ready(function() {

                document.getElementById('email').focus();
            });
        }



    }

    seeLogin() {
        this.rPass = !this.rPass;
    }

    loginUser() {

        if (this.loginForm.$valid) {
            this.errorLogin = '';
            this.dataLoading = true;
            this.validatingLogin = true;
            this.LoginService.login(this.loginDataForm.email, this.loginDataForm.password).then(response => {
                this.validatingLogin = false;
                this.dataLoading = false;
                this.dataReceived = true;
                if (!response.error) {
                    this.isAValidUser = true;
                    let cartId = this.SessionService.get('cartId') || '';
                    let clientPriceListName = '';
                    try {
                        clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
                    } catch (e) {
                    }

                    this.ByFavoritesService.getResumeProductsFavorites(response.data.userId).then(favoritesResponse => {

                        response.data.favoriteItems = favoritesResponse;

                        this.CartService.getCartResumeData(cartId, response.data.userId, true).then(cartResponse => {

                            this.cart = response;
                            this.SharedService.saveUserLogued(response.data);

                            try {
                                if (response.data.isB2B && response.data.operatingCenters) {
                                    if (response.data.isB2B && response.data.operatingCenters.length > 1) {
                                        this.showSelectModal = true;
                                        this.showModalSelectBranchUserB2B(response.data);
                                        return;
                                    } else if (response.data.operatingCenters.length === 1) {
                                        this.LoginService.setOperatingCenter(response.data.operatingCenters[0].id).then(response => {
                                            response.data.operatingCenter = response.branch;
                                            this.SharedService.saveUserLogued(response.data);
                                        }).catch(reason => {

                                        });
                                    }
                                }
                                // if (response.data.isB2B) this.$state.go('home.salesHome');
                                if (response.data.isB2B) {
                                    this.$rootScope.reloadProyect = true;
                                    this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                                    this.$state.reload();
                                }
                                else {
                                    if (this.ngAuthSettings.site.config.redirectToB2bPage &&
                                        (response.data.isSeller || response.data.isContactCenter)) {
                                        this.$rootScope.reloadProyect = true;
                                        this.$rootScope.reloadProyectState = 'home.contactCenterHome';
                                        // this.$state.go('home.contactCenterHome');
                                        this.$state.reload();
                                        return;
                                    }
                                    if (cartResponse) {
                                        if (cartResponse.items.length > 0) {
                                            this.$rootScope.reloadProyect = true;
                                            this.$rootScope.reloadProyectState = 'home.cart';
                                            this.$state.reload();
                                            // this.$state.go('home.cart');
                                        }
                                        else {
                                            // this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
                                            // this.$timeout(() => {this.$state.reload();}, 1000);
                                            this.$rootScope.reloadProyect = true;
                                            this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                                            this.$state.reload();
                                            // this.$timeout(() => {this.$state.go(this.ngAuthSettings.site.app.header.logo.url);}, 2000);

                                        }
                                        this.SessionService.put('pickupStore', cartResponse.pickupStore);
                                    }
                                    else {
                                        // this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
                                        // this.$timeout(() => {this.$state.reload();}, 1000);
                                        this.$rootScope.reloadProyect = true;
                                        this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                                        this.$state.reload();
                                        // this.$timeout(() => {this.$state.go(this.ngAuthSettings.site.app.header.logo.url);}, 2000);
                                    }
                                }
                            }
                            catch (e) {
                                alert(e.message);
                                this.$rootScope.reloadProyect = true;
                                this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                                this.$state.reload();
                            }
                        });

                    });


                } else {
                    this.errorLogin = response.message;
                    this.isAValidUser = false;
                }
            }).catch(() => {
                this.validatingLogin = false;
            });
        }
        else {
            this.userEmpty = true;
            this.passwordEmpty = true;
        }
    }

    showModalSelectBranchUserB2B(userData) {
        let options = {
            userData: userData,
            branches: userData.operatingCenters,
            currentBranch: null
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalSelectBranch,
            controller: 'ModalSelectBranchController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(result => {
            this.showSelectModal = false;
        }).catch(reason => {
            this.showSelectModal = false;
        });
    }

    registerUser() {
        if (this.registerForm.$valid) {
            this.validatingCreateUser = true;
            if (this.newUser.branchCity) this.newUser.branchCityId = this.newUser.branchCity.id;
            this.LoginService.registerUser(this.newUser).then(response => {
                this.validatingCreateUser = false;
                if (!response.error) {
                    this.successMessage = response.message;
                    this.user.email = angular.copy(this.newUser.email);
                    this.newUser = {};
                    this.registerForm.$setPristine();
                    this.$timeout(() => this.activateTab = 0, 7000);
                } else {
                    this.errorMessageRegister = response.message;
                    this.$timeout(() => this.errorMessageRegister = null, 7000);
                }
            }).catch(error => {
                this.validatingCreateUser = false;
            });
        }
    }

    // /**
    //  Set captcha id on create captcha
    //  @method widgetId
    //  @param widgetId captcha widgetr id
    //  */
    // setWidgetId (widgetId)  {
    //   this.captchaId = widgetId;
    // };
    //
    // /**
    //  Set captcha value on enter captcha
    //  @method setResponse
    //  @param response captcha value
    //  */
    // setResponse (response) {
    //   this.enteredCaptcha = true;
    //   this.expiredCaptcha = false;
    //   this.captcha = response;
    // };
    //
    // /**
    //  Expiration captcha event
    //  @method cbExpiration
    //  */
    // cbExpiration () {
    //   this.expiredCaptcha = true;
    //   this.enteredCaptcha = false;
    //
    //   this.captcha = '';
    // };
    //

    validatePassword() {
        if (this.newUser.password && this.newUser.passwordConfirm) {
            if (!angular.equals(this.newUser.password, this.newUser.passwordConfirm)) {
                this.passwordInvalid = true;
            }
        }
    }

    validateThirdDocument() {
        if (this.newUser.thirdDocumentNumber) {
            this.validatingDocument = true;
            this.SharedService.validateThirdDocument(this.newUser.thirdDocumentNumber).then(response => {
                this.validatingDocument = false;
                this.thirdDocumentInvalid = response;
            }).catch(error => {
                this.validatingDocument = false;
            });
        }
    }

    validateEmail() {
        if (this.newUser.email) {
            this.validatingEmail = true;
            this.SharedService.validateEmail(this.newUser.email).then(response => {
                this.validatingEmail = false;
                this.userEmailInvalid = response.error;
            }).catch(error => {
                this.validatingEmail = false;
            });
        }
    }

    restoreAccountByEmail() {
        if(!this.loadingRpass){

          this.loadingRpass = true;
          this.validateRestore = true;

          if (this.recoveryPasswordForm.$valid ) {
            this.LoginService.resetPassword(this.loginDataForm.email).then(response => {
              this.validateRestore = false;
              var text = "";
              let options = {};
              if (!response.error) {
                this.active = 0;
                this.loginDataForm.email = '';
                this.captchaModel = null;
                text = "Se ha enviado una nueva clave de acceso a su correo. Por seguridad, te recomendamos cambiar la contraseña la próxima vez que inicies sesión..";
                options = {
                  title: 'Cambio de clave',
                  isHtml: true,
                  content: `<div class="alert alert-success"> Se ha enviado una nueva clave de acceso a su correo.</div>`,
                  size: '',
                  showBottonCancel: false,
                  textActionCancel: '',
                  textAction: 'Aceptar'
                };

              } else {
                text = response.message;
                options = {
                  title: 'Cambio de clave',
                  isHtml: true,
                  content: '<div class="alert alert-warning">' + response.message + '</div>',
                  size: '',
                  showBottonCancel: false,
                  textActionCancel: '',
                  textAction: 'Aceptar'
                };
              }
              if (__env.adaptative) {
                this.messageMaterial(text);
              } else {
                this.messageResponse(options);
              }

              this.$state.go('home.login');
              this.$state.reload();
            }).catch((reason) => {
              if (__env.adaptative) {
                this.messageMaterial(reason.message);
              } else {
                let options = {
                  title: 'Cambio de clave',
                  isHtml: true,
                  content: `<div class="alert alert-danger">${reason.message} </div>`,
                  size: '',
                  showBottonCancel: false,
                  textActionCancel: '',
                  textAction: 'Aceptar'
                };
                this.messageResponse(options);
                this.loadingRpass = false;
              }
            });
          } else {

            if (!this.loginDataForm.email) {
              this.emailEmpty = true;
            }
            if (!this.captchaModel2) {
              this.captchaEmpty = true;
            }
            this.loadingRpass = false;
          }

        }


    }

    messageMaterial(text) {
        var mdToast = this.$mdToast;
        this.$mdToast.show({
            hideDelay: 7000,
            controller: function () {
                this.closeToast = function () {
                    mdToast.hide();
                }

            },
            controllerAs: 'toast',
            template: '<md-toast>\n' +
            '  <span class="md-toast-text">' + text + '</span>\n' +
            '  <md-button ng-click="toast.closeToast()">\n' +
            '    Cerrar\n' +
            '  </md-button>\n' +
            '</md-toast>'
        });
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }
}

LoginController.$inject = inject;

export default LoginController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/login/login.controller.js
 **/